if (typeof SnowfallEffect !== 'function') {

  class SnowfallEffect extends HTMLElement {
    constructor() {
      super();

      this.intensity = parseInt(this.dataset.intensity) || 50;
      this.duration = parseInt(this.dataset.duration) || 3;
      this.speed = this.dataset.speed || 'medium';

      // Check if effect was already shown in this session
      const hasShownSnowfall = sessionStorage.getItem('snowfall_shown');

      if (hasShownSnowfall) {
        this.classList.add('snowfall--hidden');
        return;
      }

      this.init();
    }

    init() {
      // Mark as shown for this session
      sessionStorage.setItem('snowfall_shown', 'true');

      // Create snowflakes
      this.createSnowflakes();

      // Set timeout to fade out effect
      const durationMs = this.duration * 1000;

      setTimeout(() => {
        this.fadeOut();
      }, durationMs);
    }

    createSnowflakes() {
      const fragment = document.createDocumentFragment();

      for (let i = 0; i < this.intensity; i++) {
        const snowflake = this.createSnowflake();
        fragment.appendChild(snowflake);
      }

      this.appendChild(fragment);
    }

    createSnowflake() {
      const snowflake = document.createElement('div');
      snowflake.className = `snowflake snowflake--${this.speed}`;
      snowflake.innerHTML = '❄';

      // Random horizontal position
      const leftPosition = Math.random() * 100;
      snowflake.style.left = `${leftPosition}%`;

      // Random size (0.5em to 1.5em)
      const size = Math.random() * 1 + 0.5;
      snowflake.style.fontSize = `${size}em`;

      // Random animation delay (0 to 2 seconds)
      const delay = Math.random() * 2;
      snowflake.style.animationDelay = `${delay}s`;

      // Set animation duration based on speed
      let animationDuration;
      switch(this.speed) {
        case 'slow':
          animationDuration = Math.random() * 5 + 8; // 8-13s
          break;
        case 'fast':
          animationDuration = Math.random() * 3 + 3; // 3-6s
          break;
        default: // medium
          animationDuration = Math.random() * 4 + 5; // 5-9s
      }
      snowflake.style.animationDuration = `${animationDuration}s`;

      // Random opacity (0.6 to 1)
      const opacity = Math.random() * 0.4 + 0.6;
      snowflake.style.opacity = opacity;

      return snowflake;
    }

    fadeOut() {
      this.classList.add('snowfall-container--fadeout');

      // Remove element after fade out animation completes
      setTimeout(() => {
        this.classList.add('snowfall--hidden');
      }, 1000); // 1s fade out duration
    }
  }

  customElements.define('snowfall-effect', SnowfallEffect);

}
